<template>
  <div>
    <v-container fluid>

      <div class="main">
        <v-row>
          <v-col cols="12">

            <v-card class="rounded-lg shadow">

              <v-card-title>
                Suivi tous les recouvreurs
                <v-spacer/>
                <v-btn depressed
                       exact
                       fab
                       @click="getTrakingData"
                       small
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
                &nbsp;
                <v-btn depressed
                       exact
                       fab
                       small
                       to="/recoveries">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-card-title>

              <v-divider/>


              <v-card-text>

                <v-row justify="end">
                  <v-col cols="6">
                    <v-card :loading="datesLoading" outlined class="rounded-lg">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <h3 class="mb-2">{{ CurrencyFormatting(statistics.dates ?? 0) }} DZD</h3>
                            <v-skeleton-loader v-if="datesLoading" type="text"/>
                            <div v-else class="font-weight-medium text-no-wrap">
                              Total {{ formattedDate }}
                            </div>
                          </v-col>
                          <v-col class="text-right">
                            <v-avatar color="gifty" size="42" class="rounded-lg">
                              <v-icon dark>mdi-clock-outline</v-icon>
                            </v-avatar>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col cols="12">
                            <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    block
                                    color="gifty"
                                    text
                                    class="v-btn--active"
                                    depressed
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                  <v-icon left>mdi-calendar-multiple</v-icon>
                                  {{ formattedDate }}

                                  <v-icon right @click.stop="getTrakingDataByDates">mdi-refresh</v-icon>
                                </v-btn>
                              </template>

                              <v-card>
                                <v-date-picker
                                    v-model="dateRange"
                                    range
                                    no-title
                                    scrollable
                                    @change="setDateRange"
                                ></v-date-picker>
                              </v-card>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>

                  <v-col cols="12" lg="4">
                    <v-card outlined class="rounded-lg">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <h3 class="mb-2">DZD</h3>
                            <v-skeleton-loader v-if="isLoading" type="text"/>
                            <div v-else class="font-weight-medium">
                              {{ CurrencyFormatting(statistics.current_day) }}
                            </div>
                          </v-col>
                          <v-col class="text-right">
                            <v-avatar color="teal" size="42" class="rounded-lg">
                              <v-icon dark>mdi-transfer</v-icon>
                            </v-avatar>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col cols="8">
                            <span class="white--text">Montant à verser</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="4">
                    <v-card :loading="monthLoading" outlined class="rounded-lg">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <h3 class="mb-2">DZD</h3>
                            <v-skeleton-loader v-if="isLoading || monthLoading" type="text"/>
                            <div v-else class="font-weight-medium">
                              {{ CurrencyFormatting(statistics.current_month) }}
                            </div>
                          </v-col>
                          <v-col class="text-right">
                            <v-avatar color="info" size="42" class="rounded-lg">
                              <v-icon dark>mdi-calendar-month</v-icon>
                            </v-avatar>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col cols="10">
                            <div>
                              Total mois de
                              {{
                                statistics.this_month ? months.find(el => el.value === statistics.this_month).name : ''
                              }}
                            </div>
                          </v-col>
                          <v-col class="text-right" cols="2">
                            <v-menu bottom
                                    right transition="slide-x-transition"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <strong v-bind="attrs" v-on="on">
                                  <v-icon color="info" dense>mdi-chevron-double-down</v-icon>
                                </strong>
                              </template>

                              <v-list-item-group v-model="statistics.this_month"
                                                 active-class="info white--text"
                                                 mandatory>
                                <v-list>
                                  <v-list-item v-for="(month, i) in months"
                                               :key="i"
                                               :value="month.value"
                                               @click="getTrakingDataByMonth(month.value)">
                                    <v-list-item-title>{{ month.name }}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-list-item-group>
                            </v-menu>

                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="4">
                    <v-card :loading="yearLoading" outlined class="rounded-lg">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <h3 class="mb-2">DZD</h3>
                            <v-skeleton-loader v-if="isLoading || yearLoading" type="text"/>
                            <div v-else class="font-weight-medium">
                              {{ CurrencyFormatting(statistics.current_year) }}
                            </div>
                          </v-col>
                          <v-col class="text-right">
                            <v-avatar color="primary" size="42" class="rounded-lg">
                              <v-icon dark>mdi-calendar-check</v-icon>
                            </v-avatar>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col cols="10">
                            <div>Total année {{ statistics.this_year }}</div>
                          </v-col>
                          <v-col class="text-right" cols="2">
                            <v-menu bottom
                                    right transition="slide-x-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="primary"
                                        dense
                                        v-bind="attrs" v-on="on">mdi-chevron-double-down
                                </v-icon>
                              </template>

                              <v-list-item-group v-model="statistics.this_year"
                                                 active-class="primary white--text"
                                                 mandatory>
                                <v-list>
                                  <v-list-item v-for="(year) in years"
                                               :key="year"
                                               :value="year"
                                               @click="getTrakingDataByYear(year)">
                                    <v-list-item-title>{{ year }}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-list-item-group>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="4">
                    <v-card outlined class="rounded-lg">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <h3 class="mb-2">DZD</h3>
                            <v-skeleton-loader v-if="isLoading" type="text"/>
                            <div v-else class="font-weight-medium">
                              {{ CurrencyFormatting(statistics.today_gap) }}
                            </div>
                          </v-col>
                          <v-col class="text-right">
                            <v-avatar color="indigo" size="42" class="rounded-lg">
                              <v-icon dark>mdi-calendar-today</v-icon>
                            </v-avatar>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col cols="12">
                            <span>Écart aujourd'hui</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="4">
                    <v-card outlined class="rounded-lg">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <h3 class="mb-2">DZD</h3>
                            <v-skeleton-loader v-if="isLoading" type="text"/>
                            <div v-else class="font-weight-medium">
                              {{ CurrencyFormatting(statistics.all_gap) }}
                            </div>
                          </v-col>
                          <v-col class="text-right">
                            <v-avatar color="purple" size="42" class="rounded-lg">
                              <v-icon dark>mdi-arrow-up</v-icon>
                            </v-avatar>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col cols="12">
                            <span>Reste à récupérer</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="4">
                    <v-card outlined class="rounded-lg">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <h3 class="mb-2">DZD</h3>
                            <v-skeleton-loader v-if="isLoading" type="text"/>
                            <div v-else
                                 class="font-weight-medium">
                              {{ CurrencyFormatting(statistics.recovered_amount_total) }}
                            </div>
                          </v-col>
                          <v-col class="text-right">
                            <v-avatar color="success" size="42" class="rounded-lg">
                              <v-icon dark>mdi-check-circle</v-icon>
                            </v-avatar>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col cols="12">
                            <span>Montant total récupéré</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                </v-row>

              </v-card-text>

            </v-card>

            <v-card class="shadow rounded-lg mt-3">
              <v-card-text>
                <div class="d-block d-lg-flex  justify-space-between pa-3">

                  <v-btn class="rounded-lg text-none" color="grey" text>
                    <v-icon color="success" small>mdi-circle</v-icon>
                    Validé
                  </v-btn>

                  <v-btn class="my-lg-0 my-2 rounded-lg text-none" color="grey" text>
                    <v-icon color="warning" small>mdi-circle</v-icon>
                    En attente
                  </v-btn>

                  <v-spacer/>
                </div>

                <v-card id="table" outlined>

                  <v-card-title>

                    <div>
                      <v-text-field
                          v-model="keyword"
                          append-icon="mdi-magnify"
                          clearable
                          dense
                          filled
                          hide-details
                          placeholder="Recherche..."
                          rounded
                          single-line
                      ></v-text-field>
                    </div>

                    <v-spacer/>

                    <v-btn color="grey" text>
                      <v-icon left>mdi-filter-outline</v-icon>
                      Filtre
                    </v-btn>

                    <v-btn color="grey"
                           icon
                           @click="[getRecoveries()]">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>

                  </v-card-title>

                  <v-divider/>

                  <v-card-text v-if="listLoading">
                    <v-skeleton-loader type="table"/>
                  </v-card-text>

                  <div v-else>

                    <v-card-text class="pa-0">

                      <v-simple-table v-if="recoveries.length">
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th></th>
                            <th>POS</th>
                            <th>Commune</th>
                            <th class="text-center">Ancien montant</th>
                            <th class="text-center">Montant payé</th>
                            <th class="text-center">Écart</th>
                            <th class="text-center">Service</th>
                            <th>Date de recouvrement</th>
                            <th>Source</th>
                          </tr>
                          </thead>
                          <tbody>

                          <tr v-for="(item, i) in recoveries" :key="i" class="pointer"
                              title="Cliquez pour afficher plus de détails">

                            <td @click="$refs.detailsDialog.open(item)">
                              <v-icon v-if="item.status === 'validated'" color="success">mdi-check-circle</v-icon>
                              <v-icon v-else color="warning">mdi-timer-sand</v-icon>
                            </td>

                            <td @click="$refs.detailsDialog.open(item)" class="text-no-wrap">
                              {{ item.account.user.name }}
                            </td>

                            <td @click="$refs.detailsDialog.open(item)" class="text-no-wrap">
                              {{ item.account?.salepoint?.commune?.name }}
                            </td>

                            <td class="text-center" @click="$refs.detailsDialog.open(item)">
                              <div class="font-weight-medium">
                                {{ CurrencyFormatting(item.old_amount) }}
                              </div>
                            </td>

                            <td class="text-center" @click="$refs.detailsDialog.open(item)">
                              <div class="gifty--text font-weight-medium">
                                {{ CurrencyFormatting(item.paid_amount) }}
                              </div>
                            </td>

                            <td class="text-center" @click="$refs.detailsDialog.open(item)">
                              <div class="info--text font-weight-medium text-no-wrap">
                                {{
                                  (item.paid_amount - item.old_amount) > 0 ? '+' :
                                      (item.paid_amount - item.old_amount) === 0 ? '' : '-'
                                }}{{ CurrencyFormatting(Math.abs(item.old_amount - item.paid_amount)) }}
                              </div>
                            </td>

                            <td>
                              {{ item.service?.name }}
                            </td>

                            <td class="text-no-wrap" @click="$refs.detailsDialog.open(item)">
                              {{ dateFormat(item.recovery_at) }}
                            </td>

                            <td class="text-center" @click="$refs.detailsDialog.open(item)">
                              <v-avatar color="info" size="30">
                                <v-icon v-if="item.source === 'mobile'" dark small>mdi-cellphone</v-icon>
                                <v-icon v-else dark small>mdi-desktop-mac</v-icon>
                              </v-avatar>
                            </td>

                          </tr>

                          </tbody>
                        </template>
                      </v-simple-table>

                      <div v-else>
                        <NoResults @reload="getRecoveries"/>
                      </div>

                    </v-card-text>

                    <v-divider v-if="total > 10"/>

                    <v-card-actions v-if="total > 10">

                      <div :style="{width: '120px'}">
                        <v-select v-model="perPage"
                                  :items="[10,20,30,50,100]"
                                  dense
                                  hide-details
                                  label="Ligne par page"
                                  outlined></v-select>
                      </div>

                      <v-spacer/>

                      <v-pagination v-model="pagination.current"
                                    :length="pagination.total"
                                    circle
                                    total-visible="8"
                                    @input="getRecoveries"></v-pagination>

                    </v-card-actions>

                  </div>


                </v-card>
              </v-card-text>
            </v-card>

          </v-col>

        </v-row>
      </div>

    </v-container>

    <DetailsDialog ref="detailsDialog"/>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import moment from "moment/moment";
import DetailsDialog from "@/views/recoveries/components/DetailsDialog";

export default {
  components: {
    DetailsDialog
  },
  data() {
    return {
      menu: false,
      isLoading: false,
      statistics: {},

      monthLoading: false,
      yearLoading: false,
      datesLoading: false,
      listLoading: false,

      dateRange: [],
      from: null,
      to: null,
      month: moment().format('MM'),
      year: moment().format('YYYY'),
      currentMonth: moment().format('MM'),
      currentYear: moment().format('YYYY'),

      keyword: null,
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
      recoveries: []
    };
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm');
    },
    getTrakingData() {
      this.isLoading = true
      HTTP.get('/v1/recoveries/tracking').then(res => {
        this.isLoading = false
        this.statistics = res.data.data
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    getTrakingDataByMonth(month) {
      this.monthLoading = true
      let data = {
        month: month,
      }
      HTTP.get('/v1/recoveries/tracking-month', {
        params: data
      }).then(res => {
        this.monthLoading = false
        this.statistics.current_month = res.data.data.amount
      }).catch(err => {
        this.monthLoading = false
        console.log(err)
      })
    },
    getTrakingDataByYear(year) {
      this.yearLoading = true
      let data = {
        year: year,
      }
      HTTP.get('/v1/recoveries/tracking-year', {
        params: data
      }).then(res => {
        this.yearLoading = false
        this.statistics.current_year = res.data.data.amount
      }).catch(err => {
        this.yearLoading = false
        console.log(err)
      })
    },
    setDateRange() {
      this.from = this.dateRange[0];
      this.to = this.dateRange[1];
      this.menu = false;
      this.getTrakingDataByDates();
    },
    getTrakingDataByDates() {
      this.datesLoading = true;
      const data = {
        from: this.from,
        to: this.to,
      };
      HTTP.get('/v1/recoveries/tracking-dates', {params: data})
          .then((res) => {
            this.statistics.dates = res.data.data.amount;
            this.datesLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.datesLoading = false;
          });
    },
    getRecoveries() {
      this.listLoading = true
      HTTP.get('/v1/recoveries/tracking/recoveries?page=' + this.pagination.current, {
        params: {}
      }).then(res => {
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;

        this.recoveries = res.data.data

        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
        console.log(err)
      })
    },
  },
  created() {
    this.getTrakingData()
    this.getRecoveries()
  },
  computed: {
    formattedDate() {
      if (this.from && this.to) {
        return `Du ${this.from} au ${this.to}`;
      }
      return 'Du - au';
    },
    months() {
      return [
        {name: 'Janvier', value: "01"},
        {name: 'Février', value: "02"},
        {name: 'Mars', value: "03"},
        {name: 'Avril', value: "04"},
        {name: 'Mai', value: "05"},
        {name: 'Juin', value: "06"},
        {name: 'Juillet', value: "07"},
        {name: 'Août', value: "08"},
        {name: 'Septembre', value: "09"},
        {name: 'Octobre', value: "10"},
        {name: 'Novombre', value: "11"},
        {name: 'Décembre', value: "12"}
      ]
    },
    years() {
      return ["2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030"]
    },
  }
};
</script>

<style scoped></style>
